import type { ShapeData } from '@/lib/shapes/types/shape-data'
import { syncTemplatePlacements } from '@/lib/templates/template-placement-session'

/**
 * Sync `spreadId`'s template placements with the shapes currently on it — call after any add,
 * remove, undo, redo or load, next to the ClikArt and photo equivalents.
 *
 * `removedIds` names shapes that are gone but that `shapes` may still list: the manager publishes
 * `removeShape` on the next render, so `getShapes()` keeps listing a doomed shape for the rest of
 * the gesture removing it, and right after an undo of an add or a redo of a delete. They are
 * discounted here instead of reading a list that still holds them.
 */
export function syncTemplatePlacementsWithShapes(
  shapes: readonly ShapeData[],
  spreadId: string,
  removedIds?: ReadonlySet<string>
): void {
  const liveIds = new Set<string>()

  for (const shape of shapes) {
    if (!removedIds?.has(shape.id)) liveIds.add(shape.id)
  }

  syncTemplatePlacements(spreadId, liveIds)
}
